import type {TaskStatus, TaskPriority} from '@api/tasks/types';

/** Общие типы нормализованного API; UI-словари и правила остаются в entities. */
export type {
  TaskStatus,
  TaskPriority,
  TaskComment,
  TaskParticipant,
  Task,
  CreateTaskInput,
  UpdateTaskInput,
} from '@api/tasks/types';

export const TASK_STATUS_LABELS: Record<TaskStatus, string> = {
  planned: 'В планах',
  queued: 'В очереди',
  in_progress: 'В работе',
  paused: 'Приостановлено',
  partial: 'Выполнено частично',
  done: 'Выполнено',
};

/** Цветная точка статуса (для индикатора в шапке модалки задачи). */
export const TASK_STATUS_DOT: Record<TaskStatus, string> = {
  planned: '#94A3B8',
  queued: '#60A5FA',
  in_progress: '#2563EB',
  paused: '#D97706',
  partial: '#7C3AED',
  done: '#16A34A',
};

export const TASK_PRIORITY_LABELS: Record<TaskPriority, string> = {
  high: 'Срочно',
  medium: 'Важно',
  low: 'Обычная',
};

/** Цвет фона/текста бейджа приоритета (для preview в мета-строке). */
export const TASK_PRIORITY_BADGE: Record<
  TaskPriority,
  {bg: string; color: string}
> = {
  high: {bg: '#FEE2E2', color: '#B91C1C'},
  medium: {bg: '#FEF9C3', color: '#92400E'},
  low: {bg: '#F4F4F5', color: '#71717A'},
};

export const TASK_STATUS_ORDER: TaskStatus[] = [
  'planned',
  'queued',
  'in_progress',
  'paused',
  'partial',
  'done',
];
